<template>
  <div class="row">
    <div class="col-md-12">
      <template v-for="action in actions">
        <template v-if="checkModule(action) && checkCreator(action)">
          <check-permission-for-exact-entity
            v-if="!action.forceNoEntity && !forceNotExact && action.entityId && action.entityType"
            :key="`action_exact_${object.id}_${action.id || action.event}`"
            :permissions="action.permissions || getPermissions(action.permissionTypes)"
            :permission-entity-id="action.entityId"
            :permission-entity-type="action.entityType"
            :role-entity-id="object.id"
            :role-entity-type="entityType"
          >
            <action :action="action" :object="object" :entity-type="entityType" v-on="$listeners" />
          </check-permission-for-exact-entity>

          <check-permission
            v-else
            :key="`action_${object.id}_${action.id || action.event}`"
            :permissions="action.permissions ? action.permissions : getPermissions(action.permissionTypes)"
            :entity-id="action.forceNoEntity ? undefined : action.entityId ? action.entityId : object.id"
            :entity-type="action.forceNoEntity ? undefined : action.entityType ? action.entityType : entityType"
          >
            <action :action="action" :object="object" :entity-type="entityType" v-on="$listeners" />
          </check-permission>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { actionsMixin } from '@/mixins/actions';

import Action from './Action.vue';

// @vuese
// Akcje dokumentu
// @group Components
export default {
  name: 'Actions',
  components: { Action },
  mixins: [actionsMixin],
  props: {
    // Czy wymuszać sprawdzanie uprawnień "po staremu" - bez dokładnej encji
    forceNotExact: { type: Boolean, default: false }
  }
};
</script>
